import React from 'react';
import { TableRow, TableCell, Checkbox, Chip, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const JobTitlesTableRow = ({
    item, index, isArabic, isDark, page, perPage, order, totalItems,
    selectedIds, onRowCheckboxClick, onMenuOpen,
}) => {
    const serial = order === 'asc'
        ? (page - 1) * perPage + index + 1
        : (page - 1) * perPage + (totalItems - index);
    const isOdd = index % 2 === 0;
    const isSelected = selectedIds.includes(item?.id);

    return (
        <TableRow
            hover role="checkbox" aria-checked={isSelected} selected={isSelected}
            sx={{
                cursor: 'pointer',
                '&:last-child td, &:last-child th': { border: 0 },
                backgroundColor: isDark
                    ? isOdd ? '#020617' : '#050816'
                    : isOdd ? '#F2F7FF' : '#FFFFFF',
                '&:hover': { backgroundColor: isDark ? '#111827' : '#E3F2FD' },
                transition: 'background-color 0.15s ease',
            }}
        >
            <TableCell padding="checkbox">
                <Checkbox color="primary" checked={isSelected}
                    onChange={(e) => onRowCheckboxClick(e, item?.id)} />
            </TableCell>
            <TableCell align="center">{serial}</TableCell>
            <TableCell align="center">{item?.code || '-'}</TableCell>
            <TableCell align="center">{item?.name}</TableCell>
            <TableCell align="center">{item?.department_name || '-'}</TableCell>
            <TableCell align="center">{item?.school_name || '-'}</TableCell>
            <TableCell align="center">
                <Chip
                    label={item?.is_active
                        ? isArabic ? 'مفعّل' : 'Active'
                        : isArabic ? 'موقوف' : 'Inactive'}
                    size="small"
                    color={item?.is_active ? 'success' : 'error'}
                    variant="outlined"
                />
            </TableCell>
            <TableCell align="center">
                <IconButton size="small"
                    onClick={(e) => { e.stopPropagation(); onMenuOpen(e, item); }}
                    sx={{ color: isDark ? '#E5E7EB' : '#1F2937' }}>
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default JobTitlesTableRow;
